<template>
  <div class="md-layout-item">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>assignment</md-icon>
        </div>
        <h3 class="title">ID: {{ id }}</h3>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <div class="personal-data">
              <h3 class="title">Dane osobowe:</h3>
              <div class="personal-data__item">
                <md-icon>person</md-icon>
                <span>
                  {{ nameSurname }}
                </span>
              </div>
              <div class="personal-data__item">
                <md-icon>email</md-icon>
                <span>
                  <a :href="`mailto:${order.email}`">
                    {{ order.email }}
                  </a>
                </span>
              </div>
              <div class="personal-data__item">
                <md-icon>phone</md-icon>
                <span>
                  <a :href="`tel:${order.phone}`">
                    {{ order.phone }}
                  </a>
                </span>
              </div>
              <div class="personal-data__item">
                <md-icon>event</md-icon>
                <span>
                  {{ order.date | date }}
                </span>
              </div>
              <div class="personal-data__item">
                <md-icon>event</md-icon>
                <md-field class="status-select">
                  <label>Status</label>
                  <md-select
                    v-model="order.status"
                    @md-selected="changeStatus(order.offer_id, order.status)"
                  >
                    <md-option
                      v-for="status in statuses"
                      :key="status.status_id + status.name"
                      :value="status.status_id"
                    >
                      {{ status.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </div>
          <div class="md-layout-item">
            <div class="comments">
              <h3 class="title">Komentarze</h3>
              <div
                v-for="comment in order.comments"
                :key="Date.now() + comment.comment_id"
              >
                <span>
                  {{ comment.date | date }}
                </span>
                <strong>
                  {{ comment.desc }}
                </strong>
              </div>
              <md-field>
                <label>
                  Komentarz...
                </label>
                <md-input v-model="newComment" />
              </md-field>
              <md-button class="md-info" @click="addComment">
                Dodaj komentarz
              </md-button>
            </div>
          </div>
        </div>
        <div class="md-layout" v-if="userRoleName.toLowerCase() !== 'seller'">
          <div class="md-layout-item">
            <h3 class="title">Dane doradcy:</h3>
            <div class="personal-data__item">
              <md-icon>email</md-icon>
              <span>
                <a :href="`mailto:${order.sellerEmail}`">
                  {{ order.sellerEmail }}
                </a>
              </span>
            </div>
            <div class="personal-data__item">
              <md-icon>event</md-icon>
              <span>
                {{ order.assignmentDate | date }}
              </span>
            </div>
            <div class="personal-data__item">
              <md-icon>event</md-icon>
              <md-field class="status-select">
                <label>Przypisz obsługę klienta</label>
                <md-select v-model="newSeller" @md-selected="reassignSeller">
                  <md-option
                    v-for="(usr, index) in order.usersToAssign"
                    :key="index"
                    :value="usr"
                  >
                    {{ usr }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import crmService from '../../services/crmService'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
export default {
  name: 'OrderPreview',
  components: {},
  data() {
    return {
      order: {},
      newSeller: '',
      newComment: '',
    }
  },
  props: ['id'],
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      await this.$store.dispatch('fetchStatuses')
      const { data } = await crmService.fetchOrder(this.id)
      this.order = data
      this.newSeller = this.order.sellerEmail
    },
    changeStatus(id, status) {
      this.$store.dispatch('changeStatus', {
        id,
        status,
      })
    },
    reassignSeller() {
      if (this.order.sellerEmail !== this.newSeller) {
        Swal.fire({
          closeOnEsc: false,
          closeOnClickOutside: false,
          showCloseButton: true,
          showCancelButton: true,
          icon: 'warning',
          title: `Czy napewno chesz zmienić doradcę klienta?`,
          buttonsStyling: false,
          confirmButtonClass: 'md-button md-info',
          cancelButtonText: 'Kasuj',
          cancelButtonClass: 'md-button md-danger',
        }).then(res => {
          if (res.value) {
            this.$store
              .dispatch('reassignSeller', {
                offerId: this.order.offer_id,
                sellerEmail: this.newSeller,
              })
              .then(() => {
                this.$message('Doradca został zaktualizowany')
                this.order.sellerEmail = this.newSeller
                this.order.assignmentDate = new Date()
              })
          } else {
            this.newSeller = this.order.sellerEmail
          }
        })
      }
    },
    addComment() {
      if (this.newComment.trim().length === 0) return
      this.order.comments.push({
        offer_id: this.id,
        date: new Date(),
        comment_id: new Date(),
        desc: this.newComment,
      })
      this.$store
        .dispatch('addComment', {
          id: this.id,
          comment: this.newComment,
        })
        .then(() => {
          this.newComment = ''
        })
    },
  },
  computed: {
    ...mapGetters(['statuses', 'userRoleName']),
    nameSurname() {
      return `${this.order.name} ${this.order.surname}`
    },
  },
}
</script>

<style scoped lang="scss">
.personal-data {
  font-size: 16px;
  &__item {
    display: flex;
    align-items: center;
    margin-top: 15px;
    i {
      margin: 0 15px;
    }
  }
}
.status-select {
  max-width: 300px;
}
</style>
